import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SAMPLE_DIAGRAMS } from '../data/sampleDiagrams';
import { getUniqueTypes, filterDiagramsByType, searchDiagrams } from '../utils/diagramUtils';

function SamplePanel({ onLoadDiagram }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedType, setSelectedType] = useState('all');
  
  const types = getUniqueTypes(SAMPLE_DIAGRAMS);
  
  const filteredSamples = useMemo(() => {
    let filtered = SAMPLE_DIAGRAMS;
    
    if (selectedType !== 'all') {
      filtered = filterDiagramsByType(filtered, selectedType);
    }
    
    if (searchTerm) {
      filtered = searchDiagrams(filtered, searchTerm);
    }
    
    return filtered;
  }, [searchTerm, selectedType]);

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <input
          type="text"
          placeholder="Search samples..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-base)',
            backgroundColor: 'var(--color-surface)',
            color: 'var(--color-text)',
            fontSize: 'var(--font-size-sm)',
            marginBottom: '8px'
          }}
        />
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-base)',
            backgroundColor: 'var(--color-surface)',
            color: 'var(--color-text)',
            fontSize: 'var(--font-size-sm)'
          }}
        >
          <option value="all">All Types</option>
          {types.map(type => (
            <option key={type} value={type}>
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </option>
          ))}
        </select>
      </div>
      
      {filteredSamples.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state__icon">📊</div>
          <p className="empty-state__text">No samples found</p>
        </div>
      ) : (
        <div className="sample-list">
          {filteredSamples.map(sample => (
            <div
              key={sample.id}
              className="sample-item"
              onClick={() => onLoadDiagram(sample.code)}
            >
              <div className="sample-item__type">{sample.type}</div>
              <h4 className="sample-item__name">{sample.name}</h4>
              <p className="sample-item__description">{sample.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

SamplePanel.propTypes = {
  onLoadDiagram: PropTypes.func.isRequired
};

export default SamplePanel;
